import { FaqAccordionItems } from '@app/widgets';

export const IOS_CERTIFICATE_GENERATOR_FAQS: FaqAccordionItems[] = [
  {
    question: 'What is a Certificate Signing Request (CSR)?',
    answer: [
      'A Certificate Signing Request (CSR) is a file that contains your identity information and a public key.',
      'You submit it to Apple via the Developer Portal, and Apple issues a signed certificate (.cer) in return.',
      'Learn more in our <a href="https://capawesome.io/cloud/native-builds/certificates/ios/" target="_blank">documentation</a>.',
    ].join(' '),
  },
  {
    question: 'Is my data secure?',
    answer: [
      'Yes, absolutely.',
      'The CSR and private key are generated entirely in your browser using the Web Crypto API.',
      'No data — including your private key or personal information — is ever sent to any server.',
    ].join(' '),
  },
  {
    question:
      'Which certificate type should I choose in Apple Developer Portal?',
    answer: [
      'Choose "Apple Development" for development and testing on physical devices.',
      'Choose "Apple Distribution" for App Store submissions and ad hoc distribution.',
      'You can generate separate CSRs for each certificate type using this tool.',
    ].join(' '),
  },
  {
    question: 'How do I use the .p12 file for code signing?',
    answer: [
      'The .p12 file bundles your private key and Apple-signed certificate into a single file.',
      'Upload it to Capawesome Cloud or your CI/CD platform and provide the password you set during generation.',
      'Check our <a href="https://capawesome.io/cloud/native-builds/setup/" target="_blank">setup guide</a> for step-by-step instructions.',
    ].join(' '),
  },
  {
    question: 'Why do I need to convert .cer to .p12?',
    answer: [
      'The .cer file from Apple only contains the public certificate — it does not include your private key.',
      'The .p12 format combines both the private key and certificate, which is required for code signing in CI/CD pipelines and Xcode.',
    ].join(' '),
  },
  {
    question: 'Do I need an Apple Developer account?',
    answer: [
      'Yes, you need an active Apple Developer Program membership to upload the CSR and receive a signed certificate.',
      'You can generate the CSR with this tool without an account, but you will need one to complete the process.',
    ].join(' '),
  },
];
